export default {
  slug: "countries",
  endpoint: "countries/",
  titleKey: "countries_title",
  columns: [{ field: "name", label: "f_name" }],
  fields: [{ name: "name", type: "text", label: "f_name", required: true }],
  injectOnCreate: (item, me) => ({ ...item, company: me && me.company ? me.company.id : null }),
  softDelete: true,
};
